import {Component, Input, OnChanges, OnInit} from '@angular/core';
import {ValidatorInfo} from '@core/models/validator.model';
import {InputBoolean} from 'ng-zorro-antd/core/util';

@Component({
  selector: 'extend-form',
  templateUrl: './extend-form.component.html',
})
export class ExtendFormComponent implements OnInit, OnChanges {
  @Input() position: 'bottom'|'top' = 'bottom';
  @Input() errors: any;
  @Input() errorDefs: ValidatorInfo[];
  @Input() @InputBoolean() showError: boolean = false;

  message: string = '';
  type = null;

  constructor() { }

  ngOnInit(): void {
  }

  ngOnChanges(changes:any):void {
    var errors:any = this.errors;
    this.type = null;
    this.message = null;
    if (errors && this.showError) {
      this.setErrorMessage(errors)
    }
  }

  setErrorMessage(errors: any) {
    for(let error of this.errorDefs) {
      let key = error.errorName
      if (errors[key]) {
        this.message = error.errorDescription;
        this.type = error.type ?? 'error';
        return true;
      }
    }
    return false;
  }
}
